import getDashboard from './getDashboard';
import getDashboardCounters from './getDashboardCounters';
import getUserPermissions from './getUserPermissions';
import getLoans from './loans/getLoans';
import searchLoans from './loans/searchLoans';
import getLoan from './loans/getLoan';
import getDocumentTypes from './documents/getDocumentTypes';
import getVersioningOptions from './documents/getVersioningOptions';
import setDocumentVersion from './documents/setDocumentVersion';
import setDocumentType from './documents/setDocumentType';
import getTenants from './tenants/getTenants';
import createTenant from './tenants/createTenant';
import getTenantByName from './tenants/getTenantByName';
import getLoanTypes from './loans/getLoanTypes';
import createLoanType from './loans/createLoanType';
import createLoan from './loans/createLoan';
import getLoanChecklist from './checklist/getLoanChecklist';
import uploadSourceFile from './loans/uploadSourceFile';
import getStackFilters from './documents/getStackFilters';
import getStackFilter from './documents/getStackFilter';
import setStackFilter from './documents/setStackFilter';
import saveChecklist from './checklist/saveChecklist';
import getGlobalChecklist from './checklist/getGlobalChecklist';
import testRule from './checklist/testRule';
import cloneStackFilter from './documents/cloneStackFilter';
import deleteStackFilter from './documents/deleteStackFilter';
import getAllSharedFields from './fields/getAllSharedFields';
import getFieldFilters from './fields/getFieldFilters';
import setFieldFilter from './fields/setFieldFilter';
import getFieldFilter from './fields/getFieldFilter';
import deleteFieldFilter from './fields/deleteFieldFilter';
import cloneFieldFilter from './fields/cloneFieldFilter';
import getGlobalRules from './checklist/getGlobalRules';
import getDocumentFields from './documents/getDocumentFields';
import getLoanChecklistRules from './loans/getLoanChecklistRules';
import getExternalFields from './fields/getExternalFields';
import reEvaluateLoan from './loans/reEvaluateLoan';
import acceptInvitation from './invites/acceptInvitation';
import getInvites from './invites/getInvites';
import createInvitation from './invites/createInvitation';
import getTasks from './tasks/getTasks';
import searchTasks from './tasks/searchTasks';
import getUserTasks from './tasks/getUserTasks';
import updateUserTask from './tasks/updateUserTask';
import updateUserTaskById from './tasks/updateUserTaskById';
import createUserTask from './tasks/createUserTask';
import updateExtractedField from './fields/updateExtractedField';
import reconcileExtractedField from './fields/reconcileExtractedField';
import getFieldExtractionStatus from './fields/getFieldExtractionStatus';
import checkApiHealth from './health/checkApiHealth';
import getDocumentTypeMetadata from './documents/getDocumentTypeMetadata';
import uploadSeedDataFile from './admin/uploadSeedDataFile';
import getSharedDocumentTypes from './documents/getSharedDocumentTypes';
import setUserPreferences from './user/setUserPreferences';
import getUserPreferences from './user/getUserPreferences';
import getUserSimple from './user/getUserSimple';
import getAllUsers from './user/getAllUsers';
import setBulkDocumentUpdateType from './documents/setBulkDocumentUpdate';
import getLoanDocuments from './loans/getLoanDocuments';
import downloadLoanDocumentsZip from './loans/downloadLoanDocumentsZip';
import getExtractedDocumentData from './documents/getExtractedDocumentData';
import getTenantChecklist from './checklist/getTenantChecklist';
import saveTenantChecklist from './checklist/saveTenantChecklist';
import getNotificationConfiguration from './notifications/getNotificationConfiguration';
import getNotifications from './notifications/getNotifications';
import markAsRead from './notifications/markAsRead';
import deleteNotification from './notifications/deleteNotification';
import deleteNotificationsBulk from './notifications/deleteNotificationsBulk';
import saveNotificationConfiguration from './notifications/saveNotificationConfiguration';
import getUserNotificationPreferences from './notifications/getUserNotificationPreferences';
import updateUserNotificationPreferences from './notifications/updateUserNotificationPreferences';
import getNotificationTemplates from './notifications/getNotificationTemplates';
import createNotificationTemplate from './notifications/createNotificationTemplate';
import updateNotificationTemplate from './notifications/updateNotificationTemplate';
import updateLoanChecklistRuleResults from './loans/updateLoanChecklistRuleResults';
import updateUserRole from './user/updateUserRole';
import deleteUser from './user/deleteUser';
import updateUser from './user/updateUser';
import bulkImportUsers from './user/bulkImportUsers';
import deleteLoan from './loans/deleteLoan';
import getDocumentById from './documents/getDocumentById';
import getDocumentPageOCRData from './documents/getDocumentPageOCRData';
import setDocumentTypeViewed from './documents/setDocumentViewed';
import setDocumentTypeVerified from './documents/setDocumentVerified';
import setRecentDashboardFilter from './documents/setRecentDashboardFilter';
import getRecentDashboardFilter from './documents/getRecentDashboardFilter';
import getBorrowerpairData from './borrowerpair/getBorrowerpairData';
import getExternalFieldsByLoan from './fields/getExternalFieldsByLoan';
import setExternalFieldsByLoan from './fields/setExternalFieldsByLoan';
import getIncome from './income/getIncome';
import getIncomeHistory from './income/getIncomeHistory';
import triggerIncomeCalculation from './income/triggerIncomeCalculation';
import { downloadFile } from './income/downloadFile';
import getLoanIncomes from './income/getLoanIncomes';
import createLoanIncome from './income/createLoanIncome';
import updateLoanIncome from './income/updateLoanIncome';
import deleteLoanIncome from './income/deleteLoanIncome';
import getLoanExtractedValues from './income/getLoanExtractedValues';
import updateLoanIncomeAnalysis from './income/updateLoanIncomeAnalysis';
import getIncomeFieldTypes from './incomeFields/getIncomeFieldTypes';
import createIncomeFieldType from './incomeFields/createIncomeFieldType';
import updateIncomeFieldType from './incomeFields/updateIncomeFieldType';
import deleteIncomeFieldType from './incomeFields/deleteIncomeFieldType';
import getIncomeTypes from './incomeTypes/getIncomeTypes';
import getIncomeType from './incomeTypes/getIncomeType';
import createIncomeType from './incomeTypes/createIncomeType';
import updateIncomeType from './incomeTypes/updateIncomeType';
import deleteIncomeType from './incomeTypes/deleteIncomeType';
import getIncomeEligibleDocuments from './loans/getIncomeEligibleDocuments';
import getIncomeClarityReviewTasks from './tasks/getIncomeClarityReviewTasks';
import getLoanDocDocumentTypeById from './loans/getLoanDocDocumentTypeById';
import setBorrowerPairToDocument from './fields/setBorrowerPairToDocument';
import saveUserTenant from './user/saveUserTenant';
import deleteUserTenant from './user/deleteUserTenant';
import syncUserTenants from './user/syncUserTenants';
import getFields from './fields/getFields';
import getDocumentTypeById from './documents/getDocumentTypeById';
import setDocumentMaster from './documents/setDocumentMaster';
import setFieldType from './fields/setFieldType';
import moveDocumentToTrash from './documents/moveDocumentToTrash';
import restoreDocumentFromTrash from './documents/restoreDocumentFromTrash';
import getTrashedDocuments from './documents/getTrashedDocuments';
import setUserTenant from './user/setUserTenant';
import getLOConfiguration from './configurations/getLOConfiguration';
import uploadLOConfiguration from './configurations/uploadLOConfiguration';
import saveLOConfiguration from './configurations/saveLOConfiguration';
import {
  getMySessions,
  deleteMySessions,
  deleteSessionById,
  getUsersWithActiveSessions,
  deleteAllSessionsAdmin,
} from './sessions';
import getMappingsByType from './mappings/getMappingsByType';
import getCrossValidatorMappings from './mappings/getCrossValidatorMappings';
import getAllDocumentGroupings from './documentGrouping/getAllDocumentGroupings';
import getDocumentGroupingById from './documentGrouping/getDocumentGroupingById';
import createDocumentGrouping from './documentGrouping/createDocumentGrouping';
import updateDocumentGrouping from './documentGrouping/updateDocumentGrouping';
import deleteDocumentGrouping from './documentGrouping/deleteDocumentGrouping';
import updateLoan from './loans/updateLoan';
import getAllUsersByPermission from './user/getAllUsersByPermission';
import listRoles from './roles/listRoles';
import getRoleById from './roles/getRoleById';
import createRole from './roles/createRole';
import updateRole from './roles/updateRole';
import listPermissions from './permissions/listPermissions';
import magicLinkRequest from './auth/magicLinkRequest';
import updateTenant from './tenants/updateTenant';
import getLoansByLoanNumber from './loans/getLoansByLoanNumber';
import invitationToLoan from './invites/InvitationToLoan';
import getLoanMappings from './loans/getLoanMappings';
import getCrossValidatorGlobals from './loans/getCrossValidatorGlobals';
import bulkUpdateLoanMappings from './loans/bulkUpdateLoanMappings';
import deleteLoanMapping from './loans/deleteLoanMapping';
import upsertMappingsByType from './mappings/upsertMappingByType';
import updateMappingById from './mappings/updateMappingById';
import deleteMappingById from './mappings/deleteMappingById';
import getEncompassEfolderConfiguration from './configurations/getEncompassEfolderConfiguration';
import updateLosFields from './los/updateLosFields';
import syncFromLOS from './portfolio/syncFromLOS';
import getSyncStatus from './portfolio/getSyncStatus';
import getTenantChecklistById from './checklist/getTenantChecklistById';
import syncTenantChecklist from './checklist/syncTenantChecklist';
import getChecklistSyncStatus from './checklist/getChecklistSyncStatus';
import updateRuleById from './checklist/updateRuleById';
import getLoanProcessing from './analytics/getLoanProcessing';
import getAiPerformance from './analytics/getAiPerformance';
import { getReportData, getReports } from './reports';
import getClassifierConfiguration from './configurations/getClassifierConfiguration';
import getExtractorConfiguration from './configurations/getExtractorConfiguration';
import {
  getGuidelineBuddyPreferences,
  getGuidelineBuddySession,
  saveGuidelineBuddyVerificationToken,
  sendGuidelineBuddyMessage,
} from './guidelineBuddyChat';

const ApiService = {
  loans: {
    getLoan,
    createLoan,
    getLoans,
    searchLoans,
    getLoanTypes,
    createLoanType,
    uploadSourceFile,
    getLoanChecklistRules,
    reEvaluateLoan,
    getLoanDocuments,
    downloadLoanDocumentsZip,
    updateLoanChecklistRuleResults,
    deleteLoan,
    getIncomeEligibleDocuments,
    getLoanDocDocumentTypeById,
    updateLoan,
    getLoansByLoanNumber,
    getLoanMappings,
    getCrossValidatorGlobals,
    bulkUpdateLoanMappings,
    deleteLoanMapping,
  },
  auth: {
    magicLinkRequest,
  },
  borrowerpair: {
    getBorrowerpairData,
  },
  configurations: {
    getLOConfiguration,
    uploadLOConfiguration,
    saveLOConfiguration,
    getEncompassEfolderConfiguration,
    getClassifierConfiguration,
    getExtractorConfiguration,
  },
  income: {
    getIncome,
    getIncomeHistory,
    triggerIncomeCalculation,
    downloadFile,
    getLoanIncomes,
    createLoanIncome,
    updateLoanIncome,
    deleteLoanIncome,
    getLoanExtractedValues,
    updateLoanIncomeAnalysis,
  },
  incomeFields: {
    getIncomeFieldTypes,
    createIncomeFieldType,
    updateIncomeFieldType,
    deleteIncomeFieldType,
  },
  incomeTypes: {
    getIncomeTypes,
    getIncomeType,
    createIncomeType,
    updateIncomeType,
    deleteIncomeType,
  },
  dashboard: {
    setRecentDashboardFilter,
    getRecentDashboardFilter,
  },
  mappings: {
    getMappingsByType,
    getCrossValidatorMappings,
    upsertMappingsByType,
    updateMappingById,
    deleteMappingById,
  },
  documents: {
    getDocumentById,
    getTrashedDocuments,
    getDocumentTypes,
    getVersioningOptions,
    setDocumentVersion,
    setDocumentType,
    getStackFilters,
    getStackFilter,
    setStackFilter,
    cloneStackFilter,
    deleteStackFilter,
    getDocumentFields,
    getDocumentTypeMetadata,
    getSharedDocumentTypes,
    setBulkDocumentUpdateType,
    getExtractedDocumentData,
    getDocumentPageOCRData,
    setDocumentTypeViewed,
    setDocumentTypeVerified,
    getDocumentTypeById,
    setDocumentMaster,
    moveDocumentToTrash,
    restoreDocumentFromTrash,
  },
  fields: {
    getAllSharedFields,
    getFieldFilters,
    getFieldFilter,
    setFieldFilter,
    deleteFieldFilter,
    cloneFieldFilter,
    getExternalFields,
    updateExtractedField,
    reconcileExtractedField,
    getFieldExtractionStatus,
    getExternalFieldsByLoan,
    setExternalFieldsByLoan,
    setBorrowerPairToDocument,
    getFields,
    setFieldType,
  },
  shared: {
    tenants: {
      getTenants,
      createTenant,
      getTenantByName,
      updateTenant,
    },
  },
  invites: {
    acceptInvitation,
    createInvitation,
    getInvites,
    invitationToLoan,
  },
  checklist: {
    getLoanChecklist,
    saveChecklist,
    saveTenantChecklist,
    getGlobalChecklist,
    getGlobalRules,
    testRule,
    getTenantChecklist,
    getTenantChecklistById,
    syncTenantChecklist,
    getChecklistSyncStatus,
  },
  rules: {
    updateRuleById,
  },
  tasks: {
    getTasks,
    searchTasks,
    getUserTasks,
    updateUserTask,
    updateUserTaskById,
    createUserTask,
    getIncomeClarityReviewTasks,
  },
  user: {
    setUserPreferences,
    getUserPreferences,
    getUserSimple,
    getAllUsers,
    getAllUsersByPermission,
    updateUserRole,
    deleteUser,
    updateUser,
    saveUserTenant,
    deleteUserTenant,
    syncUserTenants,
    setUserTenant,
    bulkImportUsers,
  },
  portfolio: {
    syncFromLOS,
    getSyncStatus,
    getDashboardCounters,
    getReports,
    getReportData,
  },
  health: {
    checkApiHealth,
  },
  admin: {
    uploadSeedDataFile,
  },
  analytics: {
    getLoanProcessing,
    getAiPerformance,
  },
  guidelineBuddyChat: {
    getGuidelineBuddyPreferences,
    getGuidelineBuddySession,
    saveGuidelineBuddyVerificationToken,
    sendGuidelineBuddyMessage,
  },
  notification: {
    getNotificationConfiguration,
    getNotifications,
    markAsRead,
    deleteNotification,
    deleteNotificationsBulk,
    saveNotificationConfiguration,
    getUserNotificationPreferences,
    updateUserNotificationPreferences,
    getNotificationTemplates,
    createNotificationTemplate,
    updateNotificationTemplate,
  },
  sessions: {
    getMySessions,
    deleteMySessions,
    deleteSessionById,
    getUsersWithActiveSessions,
    deleteAllSessionsAdmin,
  },
  documentGrouping: {
    getAllDocumentGroupings,
    getDocumentGroupingById,
    createDocumentGrouping,
    updateDocumentGrouping,
    deleteDocumentGrouping,
  },
  roles: {
    listRoles,
    getRoleById,
    createRole,
    updateRole,
  },
  permissions: {
    listPermissions,
  },
  los: {
    updateLosFields,
  },
  getUserPermissions,
  getDashboard,
};

export default ApiService;
